import React, { useContext } from 'react';
import { AppSettings } from '../models/AppSettings';

export const defaultAppSettings: AppSettings = {
  apiEndpoints: {
    account: window._env_.ACCOUNT_API_URL,
    loan: window._env_.LOAN_API_URL,
    leads: window._env_.LEADS_API_URL,
  },
  datadogConfig: {
    datadogEnabled: window._env_.DATADOG_ENABLED,
    applicationId: window._env_.APPLICATION_ID,
    clientToken: window._env_.CLIENT_TOKEN,
    site: window._env_.SITE,
    defaultPrivacyLevel: window._env_.DEFAULT_PRIVACY_LEVEL,
    enableExperimentalFeatures: window._env_.ENABLE_EXPERIMENTAL_FEATURES,
    env: window._env_.ENV,
    service: window._env_.SERVICE,
    sessionReplaySampleRate: window._env_.SESSSION_REPLAY_SAMPLE_RATE,
    sessionSampleRate: window._env_.SESSION_Sample_Rate,
    traceSampleRate: window._env_.TRACE_SAMPLE_RATE,
    traceContextInjection: window._env_.TRACE_CONTEXT_INJECTION,
    trackResources: window._env_.TRACK_RESOURCES,
    trackLongTasks: window._env_.TRACK_LONG_TASKS,
    trackUserInteractions: window._env_.TRACK_USER_INTERACTIONS,
    version: window._env_.DD_VERSION,
    remoteConfigurationId: window._env_.REMOTE_CONFIGURATION_ID
  },
  repayOptions: {
    directDebitEnabled: window._env_.DIRECT_DEBIT_ENABLED,
    instantEFTEnabled: window._env_.INSTANT_EFT_ENABLED,
    easyPayEnabled: window._env_.EASY_PAY_ENABLED,
    eftEnabled: window._env_.EFT_ENABLED,
    preciumEnabled: window._env_.PRECIUM_ENABLED,
    cardEnabled: window._env_.CARD_ENABLED,
    capitecPayEnabled: window._env_.CAPITEC_PAY_ENABLED,
    minimumRepayAmountInRands: window._env_.MINIMUM_REPAY_AMOUNT_IN_RANDS,
  },
  blackBoxName: window._env_.BLACK_BOX_NAME,
  companyDetails: {
    companyName: window._env_.COMPANY_NAME,
    registrationNumber: window._env_.COMPANY_REGISTRATION_NUMBER,
    ncrRegistrationNumber: window._env_.COMPANY_NCA_REGISTRATION_NUMBER,
    companyAddress: window._env_.COMPANY_ADDRESS,
    CompanyContactNumber: window._env_.COMPANY_CONTACT_NUMBER,
    companyContactEmail: window._env_.COMPANY_CONTACT_EMAIL,
  },
  isPpc: window._env_.IS_PPC,
  ppcOverides: window.PPC_OVERIDES,
  registerDisabled: window._env_.REGISTER_DISABLED,
  cfTurnstileConfig: {
    cfTurnstileDisabled: window._env_.CF_TURNSTILE_DISABLED,
    cfTurnstileForgotPasswordWidgetSiteKey: window._env_.CF_TURNSTILE_FORGOT_PASSWORD_WIDGET_SITE_KEY,
    cfTurnstileLoginWidgetSiteKey: window._env_.CF_TURNSTILE_LOGIN_WIDGET_SITE_KEY,
    cfTurnstileOtpWidgetSiteKey: window._env_.CF_TURNSTILE_OTP_WIDGET_SITE_KEY,
    cfTurnstileRegisterWidgetSiteKey: window._env_.CF_TURNSTILE_REGISTER_WIDGET_SITE_KEY,
  },
  captchaProvider: window._env_.CAPTCHA_PROVIDER,
  limiter: window._env_.LIMITER,
  limiterHeading: window._env_.LIMITER_HEADING,
  limiterSubtitle: window._env_.LIMITER_SUBTITLE,
  urgentMessageConfig: {
    urgentMessageEnabled: window._env_.URGENT_MESSAGE_ENABLED,
    urgentMessageHeading: window._env_.URGENT_MESSAGE_HEADING,
    urgentMessageText: window._env_.URGENT_MESSAGE_TEXT,
  },
  googleTagManager: {
    gtmId: window._env_.GTM_ID,
    enhancedTrackingEnabled: window._env_.ENHANCED_TRACKING_ENABLED
  },
  insurance: {
    carInsuranceEnabled: window._env_.CAR_INSURANCE_ENABLED,
    funeralCoverEnabled: window._env_.FUNERAL_COVER_ENABLED,
    funeralCoverUrl: window._env_.FUNERAL_COVER_URL,
    carInsuranceUrl: window._env_.CAR_INSURANCE_URL,
    insuranceContactNumber: window._env_.INSURANCE_CONTACT_NUMBER,
    insuranceContactEmail: window._env_.INSURANCE_CONTACT_EMAIL,
    deathBenefitEnabled: window._env_.DEATH_BENEFIT_ENABLED,
    deathBenefitIncludeBeneficiaryDetails: window._env_.DEATH_BENEFIT_INCLUDE_BENEFICIARY_DETAILS,
    deathBenefitPrimaryCTAText: window._env_.DEATH_BENEFIT_PRIMARY_CTA_TEXT,
    deathBenefitSecondaryCTAText: window._env_.DEATH_BENEFIT_SECONDARY_CTA_TEXT,
  },
  documents: {
    legalDocumentsValidityPeriod: window._env_.LEGAL_DOCUMENTS_VALIDITY_PERIOD,
  },
  optimonkConfig: {
    campaignId: window._env_.OPTIMONK_CAMPAIGN_ID,
    showOffers: window._env_.OPTIMONK_SHOW_OFFERS
  },
  pageToggles: {
    newDocumentUploadPage: window._env_.NEW_DOCUMENT_UPLOAD_PAGE,
  },
  configCat: {
    sdkKey: window._env_.CONFIG_CAT_SDK_KEY,
    pollingMode: window._env_.CONFIG_CAT_POLLING_MODE,
    pollingInterval: window._env_.CONFIG_CAT_POLLING_INTERVAL,
    baseUrl: window._env_.CONFIG_CAT_BASE_URL,
  },
  incomeVerification: {
    openBankingAutoApprovalEnabled: window._env_.OPEN_BANKING_AUTO_APPROVAL_ENABLED,
    disabledOpenBankingBanks: window._env_.DISABLED_OPEN_BANKING_BANKS

  },
  settlementLetterConfig: {
    generationEnabled: window._env_.SETTLEMENT_LETTER_GENERATION_ENABLED
  },
  strapi: {
    baseUrl: window._env_.STRAPI_URL
  },
  braze: {
    sdkEndpoint: window._env_.BRAZE_SDK_ENDPOINT,
    sdkApiKey: window._env_.BRAZE_SDK_API_KEY
  },
  declineReasonDisabled: window._env_.DECLINE_REASON_DISABLED,
  DisbursementCoolingOffEnabled: window._env_.DISBURSEMENT_COOLING_OFF_ENABLED,
  googlePlacesApiKey: window._env_.GOOGLE_PLACES_API_KEY,
  moneyAcademyEnabled: window._env_.MONEY_ACADEMY_ENABLED,
  restrictedSalaryDays: window._env_.RESTRICTED_SALARY_DAYS,
  legalBrilliance: {
    limpPricePerMonth: window._env_.LIMP_PRICE_PER_MONTH,
  }
};

export const AppSettingsContext = React.createContext<AppSettings>(defaultAppSettings);

export const useAppSettings = () => {
  return useContext(AppSettingsContext);
};

export interface AppSettingsContextProps {
  children: React.ReactNode;
}

export const AppSettingsContextProvider = (props: AppSettingsContextProps) => {
  return <AppSettingsContext.Provider value={defaultAppSettings}>{props.children}</AppSettingsContext.Provider>;
};
